import script from "./RedeEstruturada.vue?vue&type=script&setup=true&lang=js"
export * from "./RedeEstruturada.vue?vue&type=script&setup=true&lang=js"

import "./RedeEstruturada.vue?vue&type=style&index=0&id=164b3ed8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-164b3ed8"]])

export default __exports__